export const TRANSACTIONS_MOCK = {
  PENDING: {
    id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    status: 'pending',
    redirect_url: null,
    amount: '600.00',
    token: '12345',
    aggregator_id: '12345',
    aggregator_reference: 'UAG86ST1YXWD',
    others: {
      customer_id: '1231123',
      offer_id: '1231312',
      pre_loan_id: '12312312',
    },
  },
  LOGGED: {
    id: 'c5mockb4-7e4c-45f0-bd31-24019mockd0a',
    amount: '600',
    status: 'pending',
    token: '12345',
    customer_id: '123123231',
    offer_id: '123123123',
    pre_loan_id: '12312312',
    aggregator_id: '12345',
    aggregator_reference: 'UAG86MOCKXWD',
  },
  PROCESSED: {
    id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    status: 'processed',
    redirect_url:
      'http://localhost/estado?id=124123&status=processed&transaction_id=28dde0bf-377c-43b1-ba61-5ecc1c93c357&external_id=76cba97d-1377-41af-be33-23329791362c',
    amount: '600.00',
    token: '12345',
    aggregator_id: '12345',
    aggregator_reference: 'UAG86MOCKXWD',
    others: {
      customer_id: '1231123',
      offer_id: '1231312',
      pre_loan_id: null,
    },
  },
  REJECTED: {
    id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    status: 'processed',
    redirect_url:
      'http://localhost/estado?id=124123&status=processed&transaction_id=28dde0bf-377c-43b1-ba61-5ecc1c93c357&external_id=76cba97d-1377-41af-be33-23329791362c',
    amount: '600.00',
    token: '12345',
    aggregator_id: '12345',
    aggregator_reference: 'UAG86MOCKXWD',
    others: {
      customer_id: '1231123',
      offer_id: '1231312',
      pre_loan_id: null,
    },
  },
};
